import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import { api } from "@/lib/api";
import { ArrowUpRight } from "lucide-react";

export default function Weddings() {
  const [weddings, setWeddings] = useState([]);
  useEffect(() => {
    api.get("/weddings").then((r) => setWeddings(r.data)).catch(() => {});
  }, []);

  return (
    <PublicLayout>
      <section className="pt-32 md:pt-40 pb-16">
        <div className="max-w-[1500px] mx-auto px-5 md:px-10">
          <div className="eyebrow mb-4">Archive · {weddings.length} Weddings</div>
          <h1 className="font-display italic text-5xl md:text-8xl leading-[0.95] tracking-tight max-w-4xl">
            Every wedding is <br />an entire world.
          </h1>
        </div>
      </section>

      <section data-testid="weddings-list" className="pb-24">
        <div className="max-w-[1500px] mx-auto px-5 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10">
            {weddings.map((w) => (
              <Link
                key={w.id}
                to={`/weddings/${w.slug}`}
                data-testid={`wedding-card-${w.slug}`}
                className="group hover-scale relative overflow-hidden aspect-[4/5]"
              >
                <img src={w.cover_url} alt={w.name} loading="lazy" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
                <div className="absolute inset-0 p-6 md:p-10 flex flex-col justify-end">
                  <div className="eyebrow text-[color:var(--text-muted)] mb-2">{w.location}</div>
                  <div className="flex items-end justify-between gap-4">
                    <h3 className="font-display italic text-4xl md:text-6xl leading-[0.95] tracking-tight">{w.name}</h3>
                    <ArrowUpRight size={22} className="group-hover:text-[color:var(--accent)] transition-colors" />
                  </div>
                  {w.mood_line && <p className="mt-3 text-sm text-[color:var(--text-muted)] max-w-lg">{w.mood_line}</p>}
                </div>
              </Link>
            ))}
          </div>
          {weddings.length === 0 && (
            <div className="text-center py-24 text-[color:var(--text-muted)]">No weddings yet.</div>
          )}
        </div>
      </section>
    </PublicLayout>
  );
}
